import agent, { prepareHeaders } from 'api/agent';
import { CreateCategoryModel, PrintConfig } from 'store/categoryStore/reducer';

export const Category = {
    GetCategoryDetails: (asc: boolean, orderBy: string) =>
        agent.requests.get(`/Category?asc=${asc}&orderBy=${orderBy}`),
    CreateCategory: (model: CreateCategoryModel) =>
        agent.requests.put('/Category/Create', model, prepareHeaders()),
    EditCategory: (model: CreateCategoryModel, id: string) =>
        agent.requests.post(`/Category/${id}`, model),
    DisableOrEnableCategory: (ids: string[]) => agent.requests.post(`/Category/changestatus`, ids),
    DeleteCategory: (id: string) => agent.requests.delete(`/Category/${id}`),
    SetCategoryColor: (id: string, color: string) =>
        agent.requests.post(`/Category/${id}/color`, { color }),
    SetCategoryPrintConfigs: (id: string, printConfigs: PrintConfig[]) =>
        agent.requests.post(`/Category/${id}/printers-config`, printConfigs),
};
